import { AfterViewInit, ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, NgIf } from '@angular/common';
import { ClipboardModule } from '@angular/cdk/clipboard';

@Component({
  selector: 'wm-libs-copy-loader',
  templateUrl: './copy-loader.component.html',
  styleUrls: ['./copy-loader.component.scss'],
  standalone: true,
  imports: [MatTooltipModule, ClipboardModule, NgIf, TranslateModule, NgClass],
})
export class CopyLoaderComponent implements AfterViewInit {
  @Input() valueForCopy!: string;
  @Input() color!: 'green';
  @ViewChild('wmTooltip') wmTooltip!: MatTooltip;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  public displayTooltip() {
    this.wmTooltip.disabled = false;
    this.wmTooltip.show();

    setTimeout(() => {
      this.wmTooltip.disabled = true;
    }, 2000);
  }
}
